import axios from "axios";
import { useEffect, useState } from "react";
import CircularProgressBar from "../CircularProgressBar/CircularProgressBar";
import styles from "./Cards.module.css";

const Cards = () => {
  const [view, setView] = useState("Daily");

  const [leftstats, setLeftstats] = useState({
    Daily: [
      { title: "Cold Calls", percentage: 25, count: 0 },
      { title: "Warm Calls", percentage: 25, count: 0 },
      { title: "Site Visit", percentage: 25, count: 0 },
      { title: "Deal Closed", percentage: 25, count: 0 },
    ],
  });

  const [rightstats, setRightstats] = useState({
    Daily: [
      { title: "Project", percentage: 20, count: 0 },
      { title: "Campaign", percentage: 30, count: 0 },
      { title: "Prospective  Leads", percentage: 45, count: 0 },
      { title: "Contacts", percentage: 25, count: 0 },
    ],
  });

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await axios.get(
          "https://prod.toxboxai.com/api/get-dashboard-data",
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        if (res.status === 200) {
          const data = res.data;

          setRightstats((prev) => ({
            ...prev,
            Daily: prev.Daily.map((item) => {
              switch (item.title.trim().toLowerCase()) {
                case "project":
                  return { ...item, count: data.projectsCount };
                case "campaign":
                  return { ...item, count: data.campaignsCount };
                case "prospective leads":
                  return { ...item, count: data.warmCallCount };
                case "contacts":
                  return { ...item, count: data.callCountOfJoinedAndUnjoined };
                default:
                  return item;
              }
            }),
          }));

          setLeftstats((prev) => ({
            ...prev,
            Daily: prev.Daily.map((item) => {
              switch (item.title.trim().toLowerCase()) {
                case "cold calls":
                  return { ...item, count: data.coldCallCount };
                case "warm calls":
                  return { ...item, count: data.warmCallCount };
                case "site visit":
                  return { ...item, count: data.siteVisitCount };
                case "deal closed":
                  return { ...item, count: data.dealClosedCount };
                default:
                  return item;
              }
            }),
          }));
        }
      } catch (error) {
        console.error("Error fetching dashboard data:", error);
      }
    };

    fetchDashboardData();
  }, []);

  const left = leftstats[view];
  const right = rightstats[view];

  return (
    <div className={styles.cardsSection}>
      {/* <div className={styles.headerRow}>
        <div className={styles.toggleWrapper}>
          {["Daily", "Weekly", "Monthly"].map((type) => (
            <button
              key={type}
              className={`${styles.toggleButton} ${
                view === type ? styles.active : ""
              }`}
              onClick={() => setView(type)}
            >
              {type}
            </button>
          ))}
        </div>
      </div> */}
      <div className={styles.container}>
        <div className={styles.rightCards}>
          {right.map((stat, index) => (
            <div className={styles.cardsBox1} key={index}>
              <div className={styles.title1}>
                <span>{stat.title}</span>
                <br />
                <span className={styles.count}>{stat.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className={styles.cardsContainer}>
        <div className={styles.leftCards}>
          {left.map((stat, index) => (
            <div className={styles.cardsBox} key={index}>
              <div className={styles.percentage}>
                <CircularProgressBar percentage={stat.percentage} />
              </div>

              <div className={styles.title}>
                <span>{stat.title}</span>
                <br />
                <span className={styles.count}>{stat.count}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Cards;
